import { useState } from 'react'
import { H2, H4 } from '../../text'
import { Formik, Form } from 'formik'
import { Loading } from '../../animation'
import { FormikControl } from '../../input'
import { Icon, ActionButton } from '../../buttons'
import { UseOnSubmit } from '../../../hooks/useOnSubmit'
import { convertD, convertDate, addToDate } from '../../../utils/ConvertDate'

const dropdownVideoType = [
  // { key: 'Archivo', value: 'video' },
  { key: 'Enlace', value: 'url' },
]
const VideoPutLesson = (props) => {
  const {
    lesson,
    openSnackbar,
    changeModal,
    reload,
    changeInfo,
  } = props
  const [load, setload] = useState(true)
  const [status, setstatus] = useState({
    video: false,
    image: false,
  })
  const initialValues = {
    Name: lesson.name || '',
    Description: lesson.description || '',
    StartDate: convertD(lesson.startDatePerUser, 'utc') || null,
    FinishDate: convertD(lesson.finishDatePerUser, 'utc') || null,
    Public: lesson.public || false,
    VideoType: 'url',
    VideoUrl: '',
    VideoFile: null,
    ImageFile: null,
  }
  const onSubmit = async (values) => {
    setload(false)
    let formData = new FormData()
    formData.append(
      'Description',
      values.Description
        ? JSON.stringify(values.Description).replace(/"/g, "'")
        : values.Description,
    )
    formData.append('Name', values.Name)
    formData.append('Public', values.Public)
    formData.append(
      'StartDate',
      values.StartDate ? convertDate(values.StartDate) : values.StartDate,
    )
    formData.append(
      'FinishDate',
      values.FinishDate
        ? convertDate(values.FinishDate)
        : addToDate(values.StartDate, 'days', 7),
    )
    if (values.VideoType === 'url') {
      formData.append('VideoUrl', values.VideoUrl)
    } else {
      formData.append('VideoFile', values.VideoFile)
    }
    formData.append('ImageFile', values.ImageFile)
    formData.append('VideoType', values.VideoType)
    await UseOnSubmit({
      axiosParams: {
        method: 'PUT',
        url: `/lesson/${lesson.id}`,
        data: formData,
      },
      openSnackbar: openSnackbar,
      textSuccess: 'Se guardaron tus cambios',
      textWrong: 'No se pudo guardar',
      functionSuccess: reload,
    })
    setload(true)
  }
  function confirmEdit(values) {
    changeModal(
      true,
      '¿Estás seguro que quieres editar la lección?',
      '',
      'Editar',
      () => onSubmit(values),
    )
  }
  return (
    <>
      <H2 textAlign="center">Editar video</H2>
      
      <Formik
        initialValues={initialValues}
        validationSchema={null}
        onSubmit={confirmEdit}
        enableReinitialize
      >
        {(formik) => {
          return (
            <Form>
              <FormikControl
                control="input"
                type="text"
                label="Título del video"
                name="Name"
              />
              <FormikControl
                control="date"
                label="Fecha de inicio"
                name="StartDate"
                placeholderText="Fecha de inicio"
                dateFormat="MMMM d, yyyy HH:mm"
                showTimeSelect
                timeIntervals={15}
              />
              {/* <FormikControl
                control="date"
                label="Fecha de conclusión"
                name="FinishDate"
                placeholderText="Fecha de conclusión"
                dateFormat="MMMM d, yyyy HH:mm"
                showTimeSelect
                timeIntervals={15}
                selected={
                  formik.values.StartDate
                    ? new Date(addToDate(formik.values.StartDate, 'days', 7))
                    : null
                }
              /> */}
              
              <FormikControl
                name="VideoType"
                label="Opciones para subir el video"
                control="select"
                options={dropdownVideoType}
              />
              {formik.values.VideoType === 'url' && (
                <FormikControl
                  control="input"
                  type="text"
                  label="Enlace del video"
                  name="VideoUrl"
                />
              )}
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '10px',
                }}
              >
                
                {formik.values.VideoType === 'video' && (
                  <>
                    {status.video && (
                      <FormikControl
                        control="file"
                        name="VideoFile"
                        small={true}
                        label="Archivo de video"
                        uploadFiles={formik.setValues}
                        type="video/*"
                      />
                    )}
                    <Icon
                      handleModal={() =>
                        setstatus((a) => ({ ...a, video: !status.video }))
                      }
                      ico={status.video ? 'times' : 'edit'}
                    >
                      {status.video ? 'Cancelar' : 'Editar video'}
                    </Icon>
                  </>
                )}
                {status.image && (
                  <FormikControl
                    control="file"
                    name="ImageFile"
                    small={true}
                    label="Imagen de portada"
                    uploadFiles={formik.setValues}
                    type="image/*"
                  />
                )}
                <Icon
                  handleModal={() =>
                    setstatus((a) => ({ ...a, image: !status.image }))
                  }
                  ico={status.image ? 'times' : 'edit'}
                >
                  {status.image ? 'Cancelar' : 'Editar imagen'}
                </Icon>
                <FormikControl
                  control="editor"
                  label="Descripción"
                  name="Description"
                  onChange={formik.setValues}
                  data={lesson.description}
                />
                <FormikControl
                  control="input"
                  type="checkbox"
                  label="Publicar el video"
                  name="Public"
                />
              </div>
              <br />
              {load ? (
                <ActionButton
                  onCancel={() => changeInfo(<></>)}
                  textBtn="Actualizar video"
                  type="submit"
                  disabled={!formik.isValid}
                />
              ) : (
                <>
                  <Loading />
                  {formik.values.VideoFile && (
                    <H4>Esto puede tardar según el tamaño de video</H4>
                  )}
                </>
              )}
            </Form>
          )
        }}
      </Formik>
    </>
  )
}

export default VideoPutLesson
